module.exports = __webpack_public_path__ + "img/m.169e0937.jpg";